import { render } from "./size-table.vue?vue&type=template&id=df1b6adc"
import script from "./size-table.vue?vue&type=script&lang=js"
export * from "./size-table.vue?vue&type=script&lang=js"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__